import styled, { css } from 'styled-components';
import { DropdownMenu } from './Dropdown.styles';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const SelectDropdownMenu = styled(DropdownMenu).attrs<{
  'data-testid'?: string;
  $alignment?: 'left' | 'right';
}>({
  'data-testid': 'dropdown-menu',
  $alignment: 'right',
})<{
  $hasPadding?: boolean;
}>`
  width: 100%;
  max-height: 323px;
  height: auto;
  margin-top: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-radius: 14px;
  box-shadow: 5px 5px 12px 0 rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  z-index: 3;

  padding: ${({ $hasPadding }) => ($hasPadding ? '5px 10px 10px 10px' : 0)};
`;

export const SelectDropdownMenuContainer = styled.div<{
  $hasYPadding?: boolean;
}>`
  width: 100%;
  padding: 0 10px;

  ${({ $hasYPadding }) =>
    $hasYPadding &&
    css`
      padding-top: 5px;
      padding-bottom: 10px;
    `}
`;

export const SelectDropdownMenuItem = styled(Checkbox).attrs(props => ({
  dataTestId: props.dataTestId ?? 'dropdown-menu-item',
}))`
  height: 44px;
  border-bottom: none;
  padding: 0 5px 0 10px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;
  user-select: none;
  cursor: pointer;

  & label {
    cursor: pointer;
    font-size: 15px;
  }

  ${({ value }) =>
    value &&
    css`
      & label {
        color: ${({ theme }) => theme.palette.brand.main};
      }
    `}

  &:hover {
    background: ${({ theme }) => theme.palette.quartenary.background};
    & label {
      color: ${({ theme }) => theme.palette.brand.main};
    }
    & span {
      border-color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const SelectDropdownMenuItemsTitle = styled(Typography.Caption).attrs({
  $variant: '2',
})<{ $hasTopGutter?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 10201;
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 10px 15px 10px 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;
